import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewGuideDetail, updateGuideDetail } from '../../../../slices/guideDetail/thunk';
import { setRequireCloseModal } from '../../../../slices/guideDetail/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { } from '../../../../helpers/residue/backend_helper';

const GuideDetailForm = ({
	dataGuideDetail,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

    const [selectedGuideDetailCategory, setSelectedGuideDetailCategory] = useState(null);
    const handleGuideDetailCategorySelected = (optionSelected) => {
        setSelectedGuideDetailCategory(optionSelected);
    };
    const [organicCheck, setOrganicCheck] = useState(dataGuideDetail.organic);
    const [disabledCheck, setDisabledCheck] = useState(dataGuideDetail.disable);

	const selectorGuideDetail = createSelector(
		state => state.GuideDetails,
		guideDetail => ({
			isAdding: guideDetail.isAdding,
			isAdded: guideDetail.isAdded,
			isUpdating: guideDetail.isUpdating,
			isUpdated: guideDetail.isUpdated,
			isLoadingList: guideDetail.isLoadingList,
			requireCloseModal: guideDetail.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorGuideDetail);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            name: dataGuideDetail.name || '',
            code: dataGuideDetail.code || '',
            LER: dataGuideDetail.LER || '',
            volumen: dataGuideDetail.volumen || '',
		},
		validationSchema: Yup.object({
            name: Yup.string().required('Campo requerido'),
            code: Yup.string().required('Campo requerido'),
            LER: Yup.string().required('Campo requerido'),
            volumen: Yup.number()
                .typeError('debe ser un número entero')
                .required('Campo requerido'),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedGuideDetail = {
					_id: dataGuideDetail._id,
                    guide_detail_category_id: (selectedGuideDetailCategory?.item?._id ? selectedGuideDetailCategory.item._id : ''),
                    name: values.name,
                    code: values.code,
                    LER: values.LER,
                    volumen: values.volumen,
                    organic: (organicCheck ? true : false),
                    disabled: (disabledCheck ? true : false),
				};
				dispatch(updateGuideDetail(updatedGuideDetail));
			} else {
				const newGuideDetail = {
					guideDetail_category_id: (selectedGuideDetailCategory?.item?._id ? selectedGuideDetailCategory.item._id : ''),
                    name: values.name,
                    code: values.code,
                    LER: values.LER,
                    volumen: values.volumen,
                    organic: (organicCheck ? true : false),
                    disabled: (disabledCheck ? true : false),
				};
				dispatch(addNewGuideDetail(newGuideDetail));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
                            <Col lg={6}>
								<Label for='name' className='form-label'>
									Nombre
								</Label>
								<Input
									name='name'
									id='name'
									className='form-control'
									placeholder='Ingrese un nombre'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name || ''}
									invalid={
										validation.touched.name &&
										validation.errors.name
											? true
											: false
									}
								/>
								{
                                    validation.touched.name &&
                                    validation.errors.name ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.name}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={6}>
                                <GeneralSelect
                                    label='Categoría de Residuo'
                                    value={{_id: dataGuideDetail.guideDetail_category_id} || ''}
                                    className={''}
                                    // invalid={validation.touched.x && validation.errors.x ? true : false}
                                    // error={validation.errors.x}
                                    onSelect={handleGuideDetailCategorySelected}
                                    // requestApi={}
                                    itemsSelect={[]}
                                    params={{}}
                                    disabled={false}
                                />
                            </Col>
                            <Col lg={4}>
								<Label for='code' className='form-label'>
									Código
								</Label>
								<Input
									name='code'
									id='code'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.code || ''}
									invalid={
										validation.touched.code &&
										validation.errors.code
											? true
											: false
									}
								/>
								{
                                    validation.touched.code &&
                                    validation.errors.code ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.code}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={4}>
								<Label for='code' className='form-label'>
									LER
								</Label>
								<Input
									name='LER'
									id='LER'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.LER || ''}
									invalid={
										validation.touched.LER &&
										validation.errors.LER
											? true
											: false
									}
								/>
								{
                                    validation.touched.LER &&
                                    validation.errors.LER ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.LER}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={4}>
								<Label for='volumen' className='form-label'>
									Volumen
								</Label>
								<Input
									name='volumen'
									id='volumen'
									className='form-control'
									placeholder='Ingrese un código'
									type='number'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.volumen || ''}
									invalid={
										validation.touched.volumen &&
										validation.errors.volumen
											? true
											: false
									}
								/>
								{
                                    validation.touched.volumen &&
                                    validation.errors.volumen ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.volumen}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <div className='d-flex gap-3 pt-3'>
                                <div>
                                    <FormGroup className='d-flex align-items-center'>
                                        <Label className=''>
                                            <div className='d-flex'>
                                                <Input
                                                    type="checkbox"
                                                    checked={organicCheck}
                                                    onChange={(e) => setOrganicCheck(e.target.checked)}
                                                />
                                                <div className='px-1'>
                                                    ¿Es orgánico?
                                                </div>
                                            </div>
                                        </Label>
                                        {validation.touched.organic &&
                                        validation.errors.organic ? (
                                            <FormFeedback type='invalid'>
                                                {validation.errors.organic}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </div>
                                <div>
                                    {isEdit && (
                                        <FormGroup className='d-flex align-items-center'>
                                            <Label className=''>
                                                <div className='d-flex'>
                                                    <Input
                                                        type="checkbox"
                                                        checked={disabledCheck}
                                                        onChange={(e) => setDisabledCheck(e.target.checked)}
                                                    />
                                                    <div className='px-1'>
                                                        ¿Residuo inactivo?
                                                    </div>
                                                </div>
                                            </Label>
                                            {validation.touched.disabled &&
                                            validation.errors.disabled ? (
                                                <FormFeedback type='invalid'>
                                                    {validation.errors.disabled}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    )}
                                </div>
                            </div>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<Spinner size='sm' className='me-2' />
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Residuo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default GuideDetailForm;
